<template>
  <div>
    <AttachmentListItem
      style="background: transparent; border: unset; max-width: 350px"
      :attachment="attachment"
    />
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType, provide } from "vue"
import { Attachment } from "suus-api"
import { LightboxService } from "features/gallery/lightbox/lightbox.service"
import AttachmentListItem from "components/AttachmentListItem.vue"

export default defineComponent({
  name: "TextHTMLAttachmentListItem",
  components: { AttachmentListItem },
  props: {
    attachment: {
      type: Object as PropType<Attachment>,
      required: true,
    },
    lightboxService: {
      type: Object as PropType<LightboxService>,
      required: true,
    },
  },
  setup(props) {
    provide("lightboxService", props.lightboxService)
    return {}
  },
})
</script>

<style scoped></style>
